import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnreadGradedAssignmentsQueryVariables = Types.Exact<{
  classrooms?: Types.InputMaybe<Types.ClassroomsClassroomFilterInput>;
}>;


export type UnreadGradedAssignmentsQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', studentAssignments: { __typename?: 'PageOfStudentAssignment', results?: Array<{ __typename?: 'StudentAssignment', id: string, assignmentId: string, correctnessVisible?: boolean | null, dueDate?: any | null, grade?: number | null, gradesReleased?: boolean | null, hasWrittenFeedback?: boolean | null, name: string, status?: Types.StudentAssignmentStatus | null, studentHasSeenEvaluation: boolean }> | null } } | null };


export const UnreadGradedAssignmentsDocument = gql`
    query UnreadGradedAssignments($classrooms: ClassroomsClassroomFilterInput) {
  currentUser {
    studentAssignments(
      filter: {classrooms: $classrooms, gradesReleased: {eq: true}, correctnessVisible: {eq: true}, studentHasSeenEvaluation: {eq: false}}
      sort: [{field: DUE_DATE, order: DESC}]
      limit: 50
    ) {
      results {
        id
        assignmentId
        correctnessVisible
        dueDate
        grade
        gradesReleased
        hasWrittenFeedback
        name
        status
        studentHasSeenEvaluation
      }
    }
  }
}
    `;

/**
 * __useUnreadGradedAssignmentsQuery__
 *
 * To run a query within a React component, call `useUnreadGradedAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadGradedAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadGradedAssignmentsQuery({
 *   variables: {
 *      classrooms: // value for 'classrooms'
 *   },
 * });
 */
export function useUnreadGradedAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>(UnreadGradedAssignmentsDocument, options);
      }
export function useUnreadGradedAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>(UnreadGradedAssignmentsDocument, options);
        }
// @ts-ignore
export function useUnreadGradedAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>;
export function useUnreadGradedAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<UnreadGradedAssignmentsQuery | undefined, UnreadGradedAssignmentsQueryVariables>;
export function useUnreadGradedAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>(UnreadGradedAssignmentsDocument, options);
        }
export type UnreadGradedAssignmentsQueryHookResult = ReturnType<typeof useUnreadGradedAssignmentsQuery>;
export type UnreadGradedAssignmentsLazyQueryHookResult = ReturnType<typeof useUnreadGradedAssignmentsLazyQuery>;
export type UnreadGradedAssignmentsSuspenseQueryHookResult = ReturnType<typeof useUnreadGradedAssignmentsSuspenseQuery>;
export type UnreadGradedAssignmentsQueryResult = Apollo.QueryResult<UnreadGradedAssignmentsQuery, UnreadGradedAssignmentsQueryVariables>;